export default __webpack_public_path__ + "static/five-6e7bd6fefe86532610fbf721e65b92e0.png";